// extracted by mini-css-extract-plugin
export var marginNegative = "_78-5 _78-3 _78-1";
export var marginPositive = "_78-4 _78-3 _78-1";
export var modalContent = "_78-6";
export var samplesTable = "_78-8";
export var samplesTableContainer = "_78-7";
export var statBox = "_78-a";
export var tableCell = "_78-1";
export var tableCellCenter = "_78-2 _78-1";
export var tableCellRight = "_78-3 _78-1";
export var tableHeader = "_78-0";
export var trackingNumber = "_78-9";